import * as React from 'react';
import { connect } from 'react-redux';
import { Home, Modal, Print } from '../components';
import { InitialisationHelper, ConfigHelper, Authenticate, FeatureHelper, getJourneyJSON, IOutput } from '../helpers';
import store from '../store/store';
import types from '../store/types';
import { Spinner, SpinnerType, Toggle, Button } from 'office-ui-fabric-react';
import AdminToolContainer from '../containers/admintool-container';
class HomeContainer extends React.Component<any, any> {

    componentWillMount() {
        load();
        this.state = {
            isModalOpen: false,
            clicks: 0,
            themeEnabled: false
        };
    }

    setClick() {
        let clicks = this.state.clicks + 1;

        this.setState({
            clicks: clicks === 5 ? 0 : clicks,
            isModalOpen: clicks === 5,
        });
    }

    getModal() {
        let experimentalMode = this.props.experimental;

        return <Modal title={"Experimental Features"}
            isBlocking={true}
            isOpen={this.state.isModalOpen}
            errorMessages={[]}
            warningMessages={[]}
            dismissErrorMessage={() => { }}
            onDismiss={() => {
                this.setState({ isModalOpen: false });
            }}>
            <Toggle label={"Enable Experimental Features"} onChanged={(enabled) => {
                this.props.dispatch({ type: types.ENABLE_EXPERIMENTAL_FEATURES, enabled });
            }} defaultChecked={experimentalMode} value={experimentalMode} />
        </Modal>;
    }

    getComponent(isLoading: boolean) {
        if (isLoading) {
            return <Spinner className="designer-loader" type={SpinnerType.large} label="Loading dependencies..." />;
        }
        else {
            let { sidebarPinned, sidebarOpen, page, tools, process } = this.props;
            switch (page.page) {
                case "home":
                    return <Home sidebarPinned={sidebarPinned && sidebarOpen} />;
                case "upgrade":
                    return <AdminToolContainer />;
                case "print":
                    let journeyDefinition = getJourneyJSON(tools, process);
                    let { outputs, globalOutputs } = store.getState().outputsState;
                    let allOutputs: IOutput[] = globalOutputs.concat(outputs);
                    let outputDictionary: { [id: string]: string } = {};
                    allOutputs.forEach(o => {
                        outputDictionary[o.Id] = o.Name
                    });
                    return <Print
                        outputDictionary={outputDictionary}
                        journeySchema={journeyDefinition}
                        back={() => this.props.dispatch({ type: "SET_PAGE", page: "home" })}
                    />;
                default:
                    return <Home sidebarPinned={sidebarPinned && sidebarOpen} />;
            }
        }
    }

    public render() {

        if (FeatureHelper.Supports("dark_theme", this.props.features)) {
            document.body.classList.add("theme--dark");
        }
        else {
            document.body.classList.remove("theme--dark");
        }

        let { sidebarPinned, sidebarOpen, loading } = this.props;
        let component = this.getComponent(loading);
        return (<div>
            {component}
            {this.getModal()}
            <div id="evolve-version" onClick={() => { this.setClick(); }}>{window['EVOLVE_VERSION']}</div>
        </div>);
    }

};

let load = () => {
    ConfigHelper
        .loadAuthenticationSettings()
        .then(settings => {
            store.dispatch({
                type: types.SET_SUPPRESS_HASH_CHANGE,
                suppressHashChange: true
            });
            return Authenticate(settings);
        })
        .then(token => {
            let journeyId: string = window.location.hash.substring(1);
            if (journeyId !== null && journeyId.indexOf("token") === -1) {
                journeyId = journeyId.replace('/','');
                window.location.hash = '/' + journeyId;
                InitialisationHelper.init(journeyId);
            }
        });
};

window.onhashchange = () => {

    let operationState = store.getState().operationState;
    if (!operationState.suppressHashChange) {

        //reset process state
        store.dispatch({
            type: types.RESET_COMPONENTS
        });
        load();
    }
    else {
        store.dispatch({
            type: types.SET_SUPPRESS_HASH_CHANGE,
            suppressHashChange: false
        });
    }
};

let mapStateToProps = (store) => {
    return {
        sidebarPinned: store.sidebarState.pinned,
        sidebarOpen: store.sidebarState.isOpen,
        loading: store.cacheState.loading,
        experimental: store.toolsState.experimentalFeaturesEnabled,
        features: store.toolsState.features,
        tools: store.toolsState,
        page: store.pageState,
        process: store.processState
    };
};

export default connect<any, any, any>(mapStateToProps)(HomeContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/home.tsx